import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mustChangePassword, setMustChangePassword] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const mustFlag = localStorage.getItem("must_change_password") === "true";
    if (token) {
      setMustChangePassword(mustFlag);
      api.get("/auth/me")
        .then(res => setUser(res.data))
        .catch(() => { localStorage.removeItem("token"); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    localStorage.setItem("token", res.data.token);
    setUser(res.data.user);
    const must = Boolean(res.data.must_change_password);
    setMustChangePassword(must);
    if (must) localStorage.setItem("must_change_password", "true");
    else localStorage.removeItem("must_change_password");
    return res.data;
  }, []);

  const register = useCallback(async (email, password, name) => {
    const res = await api.post("/auth/register", { email, password, name });
    localStorage.setItem("token", res.data.token);
    setUser(res.data.user);
    return res.data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("must_change_password");
    setUser(null);
    setMustChangePassword(false);
  }, []);

  const clearMustChange = useCallback((val = false) => {
    setMustChangePassword(val);
    if (!val) localStorage.removeItem("must_change_password");
  }, []);

  return (
    <AuthContext.Provider value={{
      user, loading, login, register, logout,
      mustChangePassword,
      setMustChangePassword: clearMustChange,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
